import React, { useState } from "react";
import axios from "axios";
import "./AddNotification.css";
import apiConfig from "../../../apiConfig";

const AddNotification = () => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [notificationResponse, setNotificationResponse] = useState("");
  const [showModal, setShowModal] = useState(false);

  const sendNotification = () => {
    axios
      .post(`${apiConfig.baseUrl}${apiConfig.SendNotification}`, {
        title,
        body,

      })
      .then((response) => {
        setNotificationResponse(response.data);

        setShowModal(true);
        setTitle("");
        setBody("");
        alert("Notification sent successfully...");
      })
      .catch((error) => {
        if (error.response) {

          console.error("Server response error:", error.response.data);
        } else if (error.request) {

          console.error("No response received:", error.request);
        } else {

          console.error("Error:", error.message);
        }
      });
  };

  const handleSendNotification = () => {
    sendNotification();
  };

  return (
    <div className="notification-container">
      <div className="notification">
        <div className="notification-header">
          <h2>Add Notification</h2>
        </div>
        <div className="notification-body">
          <div className="form-group">
            <label>Title:</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Body:</label>
            <textarea value={body} onChange={(e) => setBody(e.target.value)} />
          </div>
          <button onClick={handleSendNotification}>Send Notification</button>


        </div>
      </div>
    </div>
  );
};

export default AddNotification;
